import { render } from "./Vocazione.vue?vue&type=template&id=79b73ed0&scoped=true"
import script from "./Vocazione.vue?vue&type=script&lang=js"
export * from "./Vocazione.vue?vue&type=script&lang=js"

import "./Vocazione.vue?vue&type=style&index=0&id=79b73ed0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\mdv-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b73ed0"]])

export default __exports__